import { subscriptionPlans } from '@/common/constants'

export const replyToEmailTypes = {
  reveni_email: 'reveni_customer_service',
  custom_email: 'custom_email',
  store_contact_email: 'store_contact_email',
}

export const replyToEmailOptions = t => [
  {
    label: t('Atención al cliente Reveni'),
    value: replyToEmailTypes.reveni_email,
    availableFor: [subscriptionPlans.advanced, subscriptionPlans.premium],
  },
  {
    label: t('Email de contacto para clientes de la tienda'),
    value: replyToEmailTypes.store_contact_email,
    availableFor: [subscriptionPlans.basic, subscriptionPlans.advanced, subscriptionPlans.premium],
  },
  {
    label: t('Email personalizado'),
    value: replyToEmailTypes.custom_email,
    availableFor: [subscriptionPlans.basic, subscriptionPlans.advanced, subscriptionPlans.premium],
  },
]

const transactionalCommunications = {
  m_request_confirmation: 'm_request_confirmation',
  m_request_on_hold: 'm_request_on_hold',
  m4_returns_delayed: 'm4_returns_delayed',
  m_restock_error: 'm_restock_error',
  m_return_label_error: 'm_return_label_error',
  m_different_export_carrier: 'm_different_export_carrier',
  m_refund_error: 'm_refund_error',
  m_alert: 'm_alert',
}

export const transactionalCommunicationsOptions = [
  {
    label: 'Nueva solicitud recibida',
    description:
      'Enviado cada vez que se reciba una nueva solicitud de cambio o devolución, indicando los detalles de esta.',
    identifier: transactionalCommunications.m_request_confirmation,
    hideForSubscriptionPlans: [],
  },
  {
    label: 'Solicitud pendiente de revisión',
    description:
      'Se envía cada vez que una solicitud de devolución o cambio se pone en espera y necesita tu revisión manual antes de continuar.',
    identifier: transactionalCommunications.m_request_on_hold,
    hideForSubscriptionPlans: [],
  },
  {
    label: 'Recordatorios',
    description:
      'Enviado máximo una vez a la semana, indicando las transacciones instantáneas a las que les queden 7 días o menos para ser validadas.',
    identifier: transactionalCommunications.m4_returns_delayed,
    hideForSubscriptionPlans: [subscriptionPlans.basic],
  },
  {
    label: 'Alerta: Error en reposición de productos.',
    description: 'Se envía cuando un error impide que los productos devueltos se repongan según lo solicitado.',
    identifier: transactionalCommunications.m_restock_error,
    hideForSubscriptionPlans: [],
  },
  {
    label: 'Alerta: Error en reembolso.',
    description: 'Se envía cuando se produce un error que impide emitir un reembolso.',
    identifier: transactionalCommunications.m_refund_error,
    hideForSubscriptionPlans: [],
  },
  {
    label: 'Alerta: Error en creación de etiqueta de devolución.',
    description:
      'Se envía cuando se produce un error que impide generar la etiqueta de devolución y enviársela al cliente.',
    identifier: transactionalCommunications.m_return_label_error,
    hideForSubscriptionPlans: [],
  },
  {
    label: 'Alerta: Documentación de exportación requerida',
    description:
      'Se envía cuando se necesita la documentación de exportación del pedido original para evitar que la devolución sea retenida en la aduana, el pago de tasas o impuestos adicionales, o que los productos sean abandonados o destruidos.',
    identifier: transactionalCommunications.m_different_export_carrier,
    hideForSubscriptionPlans: [],
  },
  {
    label: 'Alerta: Miscelánea',
    description:
      'Se envía cuando se produce un error o una situación no cubierta por los otros tipos de alerta de la página.',
    identifier: transactionalCommunications.m_alert,
    hideForSubscriptionPlans: [],
  },
]
